var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchNormal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5C5C",
  d: "M9.583 18.126c-4.708 0-8.541-3.833-8.541-8.541s3.833-8.542 8.541-8.542 8.542 3.833 8.542 8.542-3.833 8.541-8.542 8.541m0-15.833c-4.025 0-7.291 3.275-7.291 7.292s3.266 7.291 7.291 7.291 7.292-3.275 7.292-7.291c0-4.017-3.267-7.292-7.292-7.292M18.333 18.958a.62.62 0 0 1-.441-.184l-1.667-1.666a.63.63 0 0 1 0-.884.63.63 0 0 1 .883 0l1.667 1.667a.63.63 0 0 1 0 .883.62.62 0 0 1-.442.184"
})));
export default SvgSearchNormal;